<template>
  <div>
    <v-card class="mx-auto">
      <!-- <div> -->
      <v-toolbar color="blue ligthen-2" dense dark>
        <v-btn icon @click="() => (page = 'filtros')">
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-toolbar-title class="font-weight-bold"
          >PEDIDO DE COMPRA EXPRESS</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          hide-details
          single-line
          placeholder="Buscar"
          outlined
          dense
          solo-inverted
          class="buscar-app-bar"
        ></v-text-field>
        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn icon @click="goToPageCart()">
          <v-badge
            :content="getItensCart()"
            :value="getItensCart()"
            color="red"
            overlap
          >
            <v-icon>mdi-cart-outline</v-icon>
          </v-badge>
        </v-btn>
      </v-toolbar>
      <v-container class="mt-4 pa-4" v-if="page === 'filtros'">
        <BannerOrderExpress :slides="banners" />
        <FiltersBook
          :filter="filter"
          :disabledFranchise="disabledFranchise"
          :searchProducts="handleSearchProducts"
        />
      </v-container>
      <v-container class="mt-4 pa-4" v-if="page === 'produtos'">
        <ListProducts
          :marketing="filter.marketing"
          :opportunity="filter.opportunity"
          :products="products"
          :showDetailsProduct="showDetailsProduct"
          :showMoreProducts="showMoreProducts"
          :handleClickMoreProducts="handleClickMoreProducts"
          :loadingShowMoreProducts="loadingShowMoreProducts"
        />
      </v-container>
      <v-container class="mt-4 pb-4 pe-4" v-if="page === 'ficha-tecnica'">
        <ProductDetailPage
          :productSelected="productSelected"
          :products="products"
          :showDetailsProduct="showDetailsProduct"
          :goToBackPage="goToListProducts"
          :addToCart="addToCart"
          pageOrigin="express"
        />
      </v-container>
      <v-container class="mt-4 pa-4" v-if="page === 'cart'">
        <CartPage
          pageOrigin="express"
          :cart="cart"
          :providerSelected="providerSelected"
          :radioGroup="radioGroup"
          :handleDeleteProduct="handleDeleteProduct"
          :handleEditProduct="handleEditProduct"
          :goToListProducts="goToListProducts"
          :goToDetailPage="goToDetailPage"
          :onClickImage="onClickImage"
          :saveOrder="saveOrderExpress"
        />
      </v-container>
    </v-card>
    <ImageZoom
      :visible="dialogZoomPhoto"
      :closeDialog="closeDialogZoomPhoto"
      :photo="photoDialogZoom"
      :reference="referenceDialogZoom"
      :name="nameDialogZoom"
    />
  </div>
</template>

<script>
import { URL } from "@/api/config";

import * as BannerExpressAPI from "@/api/requests/BannerExpressRequest";
import FiltersBook from "@/components/Book/Page/FiltersBook";
import ListProducts from "@/components/Book/Page/ListProducts";
import ProductDetailPage from "@/components/Book/Page/ProductDetailPage";
import CartPage from "@/components/Book/Page/CartPage";
import ImageZoom from "@/components/ImageZoom";
import BannerOrderExpress from "@/components/Express/BannerOrderExpress";
import * as HTTP from "@/api/requests/base";

const CART_STORAGE = "cart_express";

export default {
  components: {
    FiltersBook,
    ListProducts,
    ProductDetailPage,
    CartPage,
    ImageZoom,
    BannerOrderExpress,
  },
  data: () => ({
    IMAGE_DEFAULT:
      "https://cdn.b4c.inf.br/storage/multiseg/original/produto-sem-foto.png",
    loading: false,
    valid: true,
    lazy: false,
    showMoreProducts: true,
    loadingShowMoreProducts: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    page: "filtros",
    pagination: {
      current_page: 1,
      last_page: 1,
      total: 0,
      from: 0,
      to: 0,
    },
    productSelected: {},
    radioGroup: "",
    cart: {
      providers: [],
    },
    products: [],
    providerSelected: {
      total: 0,
      name: "",
      quantity: "",
      products: [],
    },
    filter: {
      collection: [],
      provider: [],
      franchise: "",
      category: "",
      subcategory: "",
      type_provider: "",
      opportunity: "N",
      marketing: "N",
    },
    photoDialogZoom: "",
    referenceDialogZoom: "",
    nameDialogZoom: "",
    dialogZoomPhoto: false,
    banners: [],
    companySessionSelected: {
      id: "",
    },
    disabledFranchise: false,
  }),
  computed: {},
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    dateTimeFormatBr: function (value) {
      if (!value) return;
      let [date, hours] = value.split(" ");
      date = date.split("-").reverse().join("/");
      return `${date} ${hours}`;
    },
    dateFormatBr: function (value) {
      if (!value) return;
      let [date] = value.split(" ");
      date = date.split("-").reverse().join("/");
      return `${date}`;
    },
    formatParcel: function (value) {
      return value.toString().padStart(2, "0");
    },
  },
  watch: {
    radioGroup(newValue) {
      let localProviderSelected = this.cart.providers.find(
        (item) => item.code === newValue
      );
      this.providerSelected = localProviderSelected;
    },
  },
  created() {
    let session = localStorage.getItem(HTTP.COMMON_LOCAL_STORAGE_KEY);
    if (session) {
      session = JSON.parse(session);
      if (
        session.company_selected !== "" &&
        session.company_selected !== undefined
      ) {
        this.companySessionSelected = session.company_selected;
      }
      this.initialize();
    } else {
      this.initialize();
    }

    // this.initialize();
  },
  methods: {
    async initialize() {
      if (this.loadingStorageCart()) {
        if (this.cart.providers.length > 0) {
          this.disabledFranchise = true;
        }

        if (this.companySessionSelected.id !== "") {
          this.disabledFranchise = true;
        }
        this.getBanners();
      }
    },
    async getBanners() {
      this.loading = true;
      try {
        this.banners = await BannerExpressAPI.getAll();
      } catch (error) {
        this.banners = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    currencyEuaToBr(value) {
      if (!value) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    validate() {},
    async post() {},
    async update() {},
    async searchProducts() {
      this.loading = true;
      this.loadingShowMoreProducts = true;
      let pageString =
        this.pagination.last_page > 1
          ? `?page=${this.pagination.current_page + 1}`
          : "";
      try {
        let res = await fetch(
          `${URL}book-digital/search-express${pageString}`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify(this.filter),
          }
        );
        let response = await res.json();

        this.pagination = {
          current_page: response.current_page,
          total: response.total,
          from: response.from,
          to: response.to,
          last_page: response.last_page,
        };

        if (this.pagination.last_page > this.pagination.current_page) {
          this.showMoreProducts = true;
        } else {
          this.showMoreProducts = false;
        }

        let newsProducts = [];

        newsProducts = response.data;
        newsProducts = newsProducts.map((item) => ({
          ...item,
          image:
            item.image == ""
              ? this.IMAGE_DEFAULT
              : `http://api.sistemasergios.com.br/public${item.image}`,
          // image: `${URL_IMAGE}${item.image}`,
        }));

        if (this.pagination.current_page === 1) {
          this.products = newsProducts;
        } else {
          newsProducts.map((item) => {
            this.products.push(item);
          });
        }
        this.page = "produtos";
        this.loadingShowMoreProducts = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    showDetailsProduct(product) {
      this.page = "ficha-tecnica";
      this.productSelected = product;
      this.productSelected.qtys = this.productSelected.grid.map(() => 0);
    },
    handleEditProduct() {},
    handleDeleteProduct() {},
    addToCart() {
      let indexProvider = this.cart.providers.findIndex(
        (item) => item.provider_id === this.productSelected.provider_id
      );
      if (indexProvider > -1) {
        this.cart.providers[indexProvider].products.push(this.productSelected);
      } else {
        this.cart.providers.push({
          provider_id: this.productSelected.provider_id,
          provider_name: this.productSelected.provider_name,
          provider_code: this.productSelected.provider_code,
          franchise_id: this.filter.franchise,
          products: [this.productSelected],
        });
      }
      this.saveToStorage();
      this.page = "cart";
    },
    handleClickMoreProducts() {
      this.searchProducts();
    },
    handleSearchProducts() {
      this.pagination = {
        current_page: 1,
        last_page: 1,
        total: 0,
        from: 0,
        to: 0,
      };
      this.searchProducts();
    },
    goToListProducts() {
      if (this.products.length === 0) {
        this.page = "filtros";
      } else {
        this.page = "produtos";
      }
    },
    goToDetailPage() {
      if (
        typeof this.productSelected.id === "undefined" &&
        this.products.length === 0
      ) {
        this.page = "filtros";
      } else if (
        typeof this.productSelected.id === "undefined" &&
        this.products.length > 0
      ) {
        this.page = "produtos";
      } else {
        this.page = "ficha-tecnica";
      }
    },
    onClickImage(image, reference = "", name = "") {
      if (image == "") return;
      this.photoDialogZoom = image;
      this.referenceDialogZoom = reference;
      this.nameDialogZoom = name;
      this.dialogZoomPhoto = true;
    },
    closeDialogZoomPhoto() {
      this.dialogZoomPhoto = false;
      this.photoDialogZoom = "";
    },
    goToPageCart() {
      if (this.cart.providers.length > 0) {
        this.page = "cart";
      }
    },
    getItensCart() {
      if (this.cart.providers.length > 0) {
        return this.cart.providers
          .map((item) =>
            item.products
              .map((product) =>
                product.qtys.reduce((a, b) => parseInt(a) + parseInt(b), 0)
              )
              .reduce((a, b) => a + b, 0)
          )
          .reduce((a, b) => a + b, 0);
      }
      console.log("teste");
      return 0;
    },
    saveOrderExpress(provider, extra = {}) {
      console.log(provider);
      console.log(extra);
    },
    loadingStorageCart() {
      let storage = localStorage.getItem(CART_STORAGE);
      if (storage) {
        storage = JSON.parse(storage);
        if (typeof storage.cart !== "undefined") {
          this.cart = storage.cart;
        }
        if (typeof storage.filter !== "undefined") {
          this.filter = storage.filter;
        }
      }
      return true;
    },
    saveToStorage() {
      localStorage.setItem(
        CART_STORAGE,
        JSON.stringify({
          cart: this.cart,
          filter: this.filter,
        })
      );
    },
  },
};
</script>

<style>
.text-field-uppercase input,
.text-field-uppercase textarea {
  text-transform: uppercase;
}
</style>

<style scoped>
.card-product:hover {
  border: 1px solid #ccc;
  cursor: pointer;
}

.wrapper-selos {
  position: absolute;
  display: grid;
  z-index: 3;
  right: 0;
  top: 0;
  width: 60px;
  float: right;
}

.selo {
  width: 60px;
  float: right;
}

.wrapper-labels {
  position: absolute;
  display: grid;
  z-index: 3;
  left: 0;
  top: 0;
  float: left;
}

.mkt {
  font-size: 20px;
  font-weight: bold;
}

.opportunity {
  font-size: 20px;
  font-weight: bold;
  color: red;
}

.buscar-app-bar input::placeholder {
  color: #888 !important;
  opacity: 1 !important;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13px;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}

.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}

.table-grid-cart {
  border-collapse: collapse;
}

.table-grid-cart > thead > tr > th,
.table-grid-cart > tbody > tr > td {
  padding: 6px;
  border: 1px solid black;
}

.table-grid-cart > tbody > tr > td {
  background-color: white !important;
}
</style>
